import React, { useEffect, useRef, useState } from 'react';
import "../assets/css/custom.css";
import "../assets/css/client.css";
import "../assets/css/management.css";
import "../assets/css/font-awesome.css";
import "../assets/css/sweetalert.css";
import "../assets/css/bootstrap.min.css";
import "../assets/css/steps.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faTrash,
    faPenToSquare,
    faTimes,
    faPodcast,
    faFilePdf,
    faFileWord,
    faFileExcel,
    faFileAlt,
    faFileUpload
} from "@fortawesome/free-solid-svg-icons";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';
import ReactDOM from "react-dom";
// import { Wizard, Steps, Step, WithWizard } from "react-multistep-wizard";
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import { Stepper, Step, StepLabel } from '@mui/material';
import { Textarea } from '@material-tailwind/react';
import { Circle } from '@mui/icons-material';
import { commonAPI } from "../services/CommonAPIService"
import { ErrorSource } from '../common/constants'
import Menus from "./menus";
import { ToastContainer, toast } from 'react-toastify';
import JoditEditor from 'jodit-react';
import noticeuserupload from '../assets/img/noticeuserupload.png';
import noticeImageUpload from '../assets/img/noticeImageUpload.png'
import stopMark from '../assets/img/stop.png';
import FlatIcon from '../assets/img/notice-management.png';
import noPictures from '../assets/img/no-pictures.png';



function Noticemanagement() {
    const [fullscreen, setFullscreen] = useState(true);
    const [activeStep, setActiveStep] = useState(0);
    const steps = ['Step 1', 'Step 2', 'Step 3'];
    const [show, setShow] = useState(false);
    const [Loading, setLoading] = useState(false);
    const [NoticeList, setNoticeList] = useState("");
    const [NoticeSubject, setNoticeSubject] = useState("");
    const [NoticeDescription, setNoticeDescription] = useState("");
    const [NoticeEmail, setNoticeEmail] = useState();
    const [NoticeId, setNoticeId] = useState();
    const [Importance, setImportance] = useState("High");
    const [StartDate, setStartDate] = useState("");
    const [EndDate, setEndDate] = useState("");
    const [NoticeType, setNoticeType] = useState([]);
    const [NoticeTypeId, setNoticeTypeId] = useState([]);
    const [NoticeTypeText, setNoticeTypeText] = useState("");
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedImageShow, setSelectedImageShow] = useState(null);
    const [selectedImageTwo, setSelectedImageTwo] = useState(null)
    const [selectedImageTwoShow, setSelectedImageTwoShow] = useState(null)
    const [firstSectionButton, setFirstSectionButton] = useState(false);
    const [UserData, setUserData] = useState("");
    const [AddNoticeBtn, setAddNoticeBtn] = useState(false);
    const [UpdateNoticeBtn, setUpdateNoticeBtn] = useState(false);
    const [UpdateShow, setUpdateShow] = useState(false);
    const [UploadBtn, setUploadBtn] = useState(false);
    const [UploadImageBtn, setUploadImageBtn] = useState(true);
    const [NoticeImages, setNoticeImages] = useState([]);
    const [NoticeAddId, setNoticeAddId] = useState("");
    const [DeleteShow, setDeleteShow] = useState(false);
    const [DeleteShowImg, setDeleteShowImg] = useState(false);
    const [DeleteItem, setDeleteItem] = useState("");
    const [NoticeShowID, setNoticeShowID] = useState("");
    const [disablePointerEvents, setDisablePointerEvents] = useState(true);
    const [NoticeShow, setNoticeShow] = useState(false);
    const [NoticeUpdateShow, setNoticeUpdateShow] = useState(false);
    const [StatusSelected, setStatusSelected] = useState("PENDING");
    const [selectedDoc, setSelectedDoc] = useState(null);
    const [selectedDocName, setSelectedDocName] = useState("");
    const [selectedDocType, setSelectedDocType] = useState("");
    const [docUploadBtn, setDocUploadBtn] = useState(false);
    const editor = useRef(null);
    const [content, setContent] = useState('');

    // ──────────────────────────────────────────────────────────────
    // 1. STATES FOR DOCUMENT UPLOAD
    // ──────────────────────────────────────────────────────────────
    const [selectedDocument, setSelectedDocument] = useState(null);   // the File object
    const [UploadDocBtn, setUploadDocBtn] = useState(false); // enable Upload button

    // console.log("userData is", UserData);
    console.log("notice id", NoticeShowID)

    const handleDocumentChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        // Allowed extensions
        const allowedExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'txt'];
        const fileExtension = file.name.split('.').pop()?.toLowerCase();

        if (!allowedExtensions.includes(fileExtension)) {
            toast.error("Only PDF, DOC, DOCX, XLS, XLSX, and TXT files are allowed.");
            e.target.value = ""; // Clear the input
            return;
        }

        // Check file size: 5MB = 5 * 1024 * 1024 bytes
        const maxSize = 5 * 1024 * 1024; // 5MB in bytes
        if (file.size > maxSize) {
            toast.error("Document must be 5MB or smaller.");
            e.target.value = ""; // Clear the input
            return;
        }

        // If valid, proceed
        setSelectedDocument(file);
        setUploadDocBtn(true);
    };

    const setInputValue = (item) => {
        setShow(true)
        setAddNoticeBtn(false)
        setUpdateShow(true);
        setUpdateNoticeBtn(true)
        setUploadImageBtn(false)
        console.log("item is", item, convertISSet(item?.effectiveStartDt))
        setNoticeId(item?.noticeId)
        setNoticeShowID(item?.noticeId)
        setNoticeShow(false)
        setNoticeUpdateShow(false)
        setNoticeSubject(item?.noticeSubject)
        setContent(item?.noticeDescription)
        setNoticeTypeId([item?.noticeTypeId, item?.noticeTypeText])
        setImportance(item?.importance)
        setStartDate(convertISSet(item?.effectiveStartDt))
        setEndDate(convertISSet(item?.effectiveEndDt))
        setNoticeAddId(item?.noticeId)
        // GetNoticeImages();
        // var decodedString1 = atob(item?.image1);
        // setSelectedImage(decodedString1)
        setSelectedImageShow("")
        setSelectedImageTwo("")
        // var decodedString2 = atob(item?.image2);
        // setSelectedImageTwo(decodedString2)
        setSelectedImageTwoShow("")
    };

    const viewModal = (item) => {
        setShow(true)
        setAddNoticeBtn(false)
        setUpdateShow(false);
        setUpdateNoticeBtn(false)
        setUploadImageBtn(true)
        console.log("item is", item, convertISSet(item?.effectiveStartDt))
        setNoticeId(item?.noticeId)
        setNoticeShowID(item?.noticeId)
        setNoticeShow(false)
        setNoticeUpdateShow(false)
        setNoticeSubject(item?.noticeSubject)
        setContent(item.noticeDescription)
        setNoticeTypeId([item.noticeTypeId, item.noticeTypeText])
        setImportance(item.importance)
        setStartDate(convertISSet(item?.effectiveStartDt))
        setEndDate(convertISSet(item?.effectiveEndDt))
        setNoticeAddId(item?.noticeId)
        // GetNoticeImages();
        // var decodedString1 = atob(item?.image1);
        // setSelectedImage(decodedString1)
        setSelectedImageShow("")
        setSelectedImage("")
        setSelectedImageTwo("")
        // var decodedString2 = atob(item?.image2);
        // setSelectedImageTwo(decodedString2)
        setSelectedImageTwoShow("")
    };

    useEffect(() => {
        if (NoticeAddId) {
            GetNoticeImages();
        }
    }, [NoticeAddId])

    const openCreateModal = () => {
        setShow(true)
        setUpdateShow(true);
        setAddNoticeBtn(true)
        setUpdateNoticeBtn(false)
        setUploadImageBtn(true)
        setNoticeSubject("")
        setNoticeDescription("")
        setNoticeEmail("")
        setNoticeShow(false)
        setNoticeUpdateShow(false)
        setNoticeAddId("")
        // setNoticeTypeId([item.noticeTypeId, item.noticeTypeText])
        setImportance("High")
        setStartDate("")
        setEndDate("")
        setSelectedImage("")
        setSelectedImageTwo("");
        setNoticeImages("")
        setContent("")
    }
    function ImageUpload() {
        const [selectedImage, setSelectedImage] = useState(null);

        const handleFileInputChange = (event) => {
            const file = event.target.files[0];

            if (file) {
                const reader = new FileReader();
                var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
                reader.onload = () => {
                    setSelectedImage(base64result);
                };
                console.log("base64", base64result)
                reader.readAsDataURL(file);
                return
            }
        };
    }

    const convertISTTime = (date) => {
        if (date != null || date != "" || date != undefined) {
            const [datePart, TimePart] = date.split(" ");
            const [mm, dd, yyyy] = datePart.split("/");
            // const [hh, mn, ss] = TimePart.split(':')
            const formatedTime = `${dd}-${mm}-${yyyy}`;
            return formatedTime;
        } else {
            console.warn("input date string may be null, empty string or undefined");
        }
    }

    const convertISSet = (date) => {
        if (date != null || date != "" || date != undefined) {
            let [datePart, TimePart] = date.split(" ");
            let [mm, dd, yyyy] = datePart.split("/");
            // const [hh, mn, ss] = TimePart.split(':')
            // if(mm<10){mm.padStart(2, "0")};
            // if(dd<10){dd.padStart(2, "0")};
            if (mm < 10) {
                mm = "0" + mm
            }
            if (dd < 10) {
                dd = "0" + dd
            }
            const formatedTime = `${yyyy}-${mm}-${dd}`;
            return formatedTime;
        } else {
            console.warn("input date string may be null, empty string or undefined");
        }
    }

    const convertTimePost = (date) => {
        if (date != null || date != "" || date != undefined) {
            const [datePart, TimePart] = date.split(" ");
            const [yyyy, mm, dd] = datePart.split("-");
            // const [hh, mn, ss] = TimePart.split(':')
            const formatedTime = `${mm}/${dd}/${yyyy}`;
            return formatedTime;
        } else {
            console.warn("input date string may be null, empty string or undefined");
        }
    };

    //   const endPointVariableKey    = {
    //     urlVariable:null,
    //     buildingId: 33

    //   }

    const getYesterdayDate = () => {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        const dd = String(yesterday.getDate()).padStart(2, '0');
        const mm = String(yesterday.getMonth() + 1).padStart(2, '0');
        const yyyy = yesterday.getFullYear();
        return `${mm}/${dd}/${yyyy}`;
    };

    // Helper function to get today's date in mm/dd/yyyy format
    const getTodayDate = () => {
        const today = new Date();
        const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const dd = String(today.getDate()).padStart(2, '0');
        const yyyy = today.getFullYear();
        return `${mm}/${dd}/${yyyy}`;
    }

    const GetNoticeList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        setUserData(myUserData);
        const endPointVariableKey = {
            urlVariable: null,
            buildingId: myUserData?.buildingId
        }

        const bodydata = {
            "noticeId": 0,
            "currentStatus": StatusSelected === "EXPIRED" ? "APPROVED" : StatusSelected,
            "validUpto": StatusSelected === "EXPIRED" ? getYesterdayDate() : getTodayDate(),
            // "effectiveEndDt": StatusSelected === "EXPIRED" ? getYesterdayDate() : null
        };

        // const bodydata = {
        //     "noticeId": 0,
        //     "currentStatus": null,
        //     "validUpto": getTodayDate(),
        // };
        try {
            let Key = 'Notice';
            if ( StatusSelected ===  "EXPIRED" ){
                Key = "ExpiredNoticeList"
            }

            setLoading(true);
            let response = await commonAPI(Key, bodydata, endPointVariableKey)
            if (response?.success === true) {
                console.log("NoticeList", response)
                const tempData = StatusSelected === "EXPIRED"
                    ? response?.data
                    : response?.data.filter((item) => item.currentStatus == StatusSelected);
                setNoticeList(tempData);
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber, // Need to be change
                "requestJSON": bodydata,
                "uri": "/api/Master/Notice",
                "errorNumber": "NL01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "Noticemanagement.js",
                "functionName": "GetNoticeList",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError)

            if (response?.success === true && response?.message?.length == 0) {
                toast.error("Something went wrong ");
                setLoading(false);
            } else {
                toast.error("Something went wrong ");
                setLoading(false);
            }
        }

    }


    const handleDocChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const ext = file.name.split('.').pop()?.toLowerCase();
        if (!['pdf', 'xls', 'xlsx'].includes(ext)) {
            toast.error("Only PDF, XLS, XLSX are allowed.");
            return;
        }
        if (file.size > 2_000_000) {
            toast.error("Document must be ≤ 2 MB.");
            return;
        }

        const reader = new FileReader();
        reader.onload = () => {
            const b64 = (reader.result).split(',')[1];
            setSelectedDoc(b64);
            setSelectedDocName(file.name);
            setSelectedDocType(ext);
            setDocUploadBtn(true);
        };
        reader.readAsDataURL(file);
    };

    // Document upload API call
    const uploadDocument = async () => {
        if (!selectedDoc) return;
        const body = {
            noticeId: NoticeAddId,
            docImage: selectedDoc,
            docName: selectedDocName,
            docType: selectedDocType,
            modifiedUserId: JSON.stringify(UserData?.userId),
        };
        try {
            setLoading(true);
            const ep = { urlVariable: null, buildingId: UserData?.buildingId };
            const res = await commonAPI("NoticeImagesAdd", body, ep);
            if (res?.success && res?.message?.length === 0) {
                toast.success("Document uploaded");
                setSelectedDoc(null);
                setSelectedDocName("");
                setSelectedDocType("");
                setDocUploadBtn(false);
                GetNoticeImages();
            } else {
                toast.error(res?.message?.[0] ?? "Failed");
            }
        } catch (err) {
            toast.error(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (selectedImageTwo) {
            setUploadBtn(true);
        } else {
            setUploadBtn(false);
        }
    }, [selectedImageTwo])

    useEffect(() => {
        GetNoticeList();
        GetNoticeType();
    }, [])

    useEffect(() => {
        GetNoticeList();
    }, [StatusSelected])

    const GetNoticeType = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);
        const endPointVariableKey = {
            urlVariable: null,
            buildingId: myUserData?.buildingId
        }
        try {
            setLoading(true);
            let response = await commonAPI("NoticeType", undefined, endPointVariableKey)
            if (response?.success === true && response?.message?.length == 0) {
                // console.log("Notice Type", response)
                setNoticeType(response?.data)
                setNoticeTypeId([response?.data[0]?.noticeTypeId, response?.data[0]?.noticeTypeText])
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber, // Need to be change
                "requestJSON": null,
                "uri": "/api/Master/NoticeType",
                "errorNumber": "NT01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "Noticemanagement.js",
                "functionName": "GetNoticeType",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError)

            if (response?.success === true && response?.message?.length == 0) {
                toast.error("Something went wrong ");
                setLoading(false);
            } else {
                toast.error("Something went wrong ");
                setLoading(false);
            }
        }

    }



    const AddNoticeData = async () => {
        const bodydata = {
            "noticeSubject": NoticeSubject,
            "noticeDescription": content,
            "noticeTypeId": NoticeTypeId[0],
            "noticeTypeText": NoticeTypeId[1],
            "importance": Importance,
            "effectiveStartDt": convertTimePost(StartDate),
            "effectiveEndDt": convertTimePost(EndDate),
            "createdUserId": JSON.stringify(UserData?.userId),
        };

        try {
            setLoading(true);
            if (!NoticeTypeId) {
                toast.warning("Please select Notice Type");
                setLoading(false);
            } else if (!Importance) {
                toast.warning("Please select Importance");
                setLoading(false);
            } else if (!StartDate) {
                toast.warning("Please select Effective Start Date");
                setLoading(false);
            } else if (!EndDate) {
                toast.warning("Please select Effective End Date");
                setLoading(false);
            } else if (!NoticeSubject) {
                toast.warning("Please enter Notice Subject");
                setLoading(false);
            } else if (!content) {
                toast.warning("Please enter Notice Description");
                setLoading(false);
            } else {
                const endPointVariableKey = {
                    urlVariable: null,
                    buildingId: UserData?.buildingId

                }
                console.log("body", bodydata);
                let response = await commonAPI("NoticeAdd", bodydata, endPointVariableKey)
                if (response?.success === true && response?.message.length == 0) {
                    console.log("NoticeAddApi", response)
                    toast.success("Notice Added");
                    setLoading(false);
                    setNoticeShowID(response?.data?.noticeId)
                    setDisablePointerEvents(false)
                    setUploadImageBtn(false);
                    setNoticeAddId(response?.data?.noticeId)
                    GetNoticeList();
                    setNoticeShow(true);
                    setUpdateShow(false);
                    setAddNoticeBtn(false)
                } else {
                    setLoading(false);
                    toast.error(response?.message[0]);
                }
            }

        } catch (error) {
            setLoading(false);
            const bodyError = {
                "userId": UserData.userId,
                "mobileNumber": UserData.mobileNumber, // Need to be change
                "requestJSON": bodydata,
                "uri": "/api/Master/Notice",
                "errorNumber": "AN01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Noticemanagement.js",
                "functionName": "AddNoticeData",
            }
            let response = await commonAPI("ErrorLogMaster", bodyError)

            if (response?.success === true & response?.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                toast.error("Something went wrong");
                setLoading(false);
            }
        }



    }

    const AddNoticeImage = async () => {
        const bodydata = {
            "modifiedUserId": JSON.stringify(UserData?.userId),
            "noticeId": NoticeAddId,
            "docImage": selectedImageTwoShow
        };

        try {
            setLoading(true);
            const endPointVariableKey = {
                urlVariable: null,
                buildingId: UserData?.buildingId

            }
            if (!selectedImageTwo) {
                toast.warning("Please upload the image");
            } else {
                console.log("body", bodydata);
                let response = await commonAPI("NoticeImagesAdd", bodydata, endPointVariableKey)
                if (response?.success === true && response?.message.length == 0) {
                    console.log("Notice Image Api", response)
                    toast.success("Image Added");
                    setLoading(false);
                    setUploadBtn(true);
                    GetNoticeImages();
                    setSelectedImageTwo("");
                } else {
                    setLoading(false);
                    toast.error(response?.message[0]);
                }
            }
        } catch (error) {
            setLoading(false);
            const bodyError = {
                "userId": UserData.userId,
                "mobileNumber": UserData.mobileNumber, // Need to be change
                "requestJSON": bodydata,
                "uri": "/api/Master/NoticeImages",
                "errorNumber": "NI01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Noticemanagement.js",
                "functionName": "AddNoticeImage",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError)

            if (response?.success === true & response?.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                toast.error("Something went wrong");
                setLoading(false);
            }
        }



    }

    const GetNoticeImages = async () => {
        const endPointVariableKey = {
            urlVariable: NoticeAddId,
            buildingId: UserData?.buildingId
        }
        try {
            setLoading(true);
            let response = await commonAPI("NoticeImages", undefined, endPointVariableKey)
            if (response?.success === true && response?.message?.length == 0) {
                console.log("Notice Get Images", response)

                setNoticeImages(response?.data)
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber, // Need to be change
                "requestJSON": null,
                "uri": "/api/Master/Notice/Images",
                "errorNumber": "NI01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "Noticemanagement.js",
                "functionName": "GetNoticeImages",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError)

            if (response?.success === true && response?.message?.length == 0) {
                toast.error("Something went wrong ");
                setLoading(false);
            } else {
                toast.error("Something went wrong ");
                setLoading(false);
            }
        }

    }

    const ShowDeleteImgModal = (item) => {
        console.log("setDeleteShowImg", item)
        setDeleteShowImg(true);
        setDeleteItem(item)

    }

    const DeleteNoticeImages = async () => {
        const endPointVariableKey = {
            urlVariable: null,
            buildingId: UserData?.buildingId
        }
        console.log("delete image item", DeleteItem)
        const bodydata = {
            "modifiedUserId": JSON.stringify(UserData?.userId),
            "noticeDocId": DeleteItem.noticeDocId,
            "noticeId": DeleteItem.noticeId,
            // "docImage": DeleteItem.docImage
        };
        try {
            console.log("delete image body", bodydata)
            setLoading(true);
            let response = await commonAPI("NoticeImagesDelete", bodydata, endPointVariableKey)
            if (response?.success === true && response?.message?.length == 0) {
                console.log("Notice Get Images", response)
                toast.success("Image Deleted");
                setLoading(false);
                GetNoticeImages();
                setDeleteShowImg(false);
            } else {
                setLoading(false);
                toast.error(response.message[0]);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = {
                "mobileNumber": UserData?.mobileNumber, // Need to be change
                "requestJSON": null,
                "uri": "/api/Master/Notice/Images",
                "errorNumber": "NI01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "Noticemanagement.js",
                "functionName": "GetNoticeImages",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError)

            if (response?.success === true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                toast.error("Something went wrong");
                setLoading(false);
            }
        }

    }

    const UpdateNoticeData = async () => {
        const bodydata = {
            "noticeId": NoticeId,
            "noticeSubject": NoticeSubject,
            "noticeDescription": content,
            "noticeTypeId": NoticeTypeId[0],
            "noticeTypeText": NoticeTypeId[1],
            "importance": Importance,
            "effectiveStartDt": convertTimePost(StartDate),
            "effectiveEndDt": convertTimePost(EndDate),
            "modifiedUserId": JSON.stringify(UserData?.userId),
        };
        try {
            console.log("body", bodydata);
            setLoading(true);
            if (!NoticeTypeId.length) {
                toast.warning("Please select Notice Type");
                setLoading(false);
            } else if (!Importance) {
                toast.warning("Please select Importance");
                setLoading(false);
            } else if (!StartDate) {
                toast.warning("Please select Effective Start Date");
                setLoading(false);
            } else if (!EndDate) {
                toast.warning("Please select Effective End Date");
                setLoading(false);
            } else if (!NoticeSubject) {
                toast.warning("Please enter Notice Subject");
                setLoading(false);
            } else if (!content) {
                toast.warning("Please enter Notice Description");
                setLoading(false);
            } else {

                const auth = localStorage.getItem("userData");
                const myUserData = JSON.parse(auth);
                // setUserData(myUserData);
                // setLoading(true);
                const endPointVariableKey = {
                    urlVariable: null,
                    buildingId: myUserData?.buildingId

                }
                let response = await commonAPI("NoticeUpdate", bodydata, endPointVariableKey)
                if (response.success === true && response.message.length == 0) {
                    toast.success("Notice Updated");
                    // setShow(false)
                    GetNoticeList();
                    setLoading(false);
                    setNoticeUpdateShow(true);
                } else {
                    toast.error(response.message[0]);
                    setLoading(false);
                }
            }

        } catch (error) {
            setLoading(false);
            const bodyError = {
                "userId": UserData.userId,
                "mobileNumber": UserData.mobileNumber, // Need to be change
                "requestJSON": bodydata,
                "uri": "/api/Master/Notice",
                "errorNumber": "NU01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Noticemanagement.js",
                "functionName": "UpdateNoticeData",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError)

            if (response?.success === true && response?.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                toast.error("Something went wrong");
                setLoading(false);
            }
        }

    }

    const ShowDeleteModal = (item) => {
        setDeleteShow(true);
        setNoticeId(item)

    }
    const DeleteNotice = async () => {
        const bodydata = {
            "noticeId": NoticeId?.noticeId,
            "modifiedUserId": JSON.stringify(UserData?.userId),
        };
        try {
            setLoading(true);
            const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);

            const endPointVariableKey = {
                urlVariable: null,
                buildingId: myUserData?.buildingId

            }
            console.log("body", bodydata);
            let response = await commonAPI("NoticeDelete", bodydata, endPointVariableKey)

            console.log("statusCode", response)
            if (response?.success == true & response?.message.length == 0) {
                toast.success("Notice Deleted");
                setDeleteShow(false)
                GetNoticeList();
                setLoading(false);
            } else {
                toast.error(response.message[0]);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            const bodyError = {
                "userId": UserData.userId,
                "mobileNumber": UserData.mobileNumber, // Need to be change
                "requestJSON": bodydata,
                "uri": "/api/Master/Notice",
                "errorNumber": "ND01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Noticemanagement.js",
                "functionName": "DeleteNotice",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError)

            if (response.success === true && response.message.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                toast.error("Something went wrong");
                setLoading(false);
            }

        }

    }



    const getFileName = (url) => decodeURIComponent(url.split('/').pop().split('?')[0]);

    const getFileIconFromUrl = (url) => {
        const ext = url.split('.').pop().toLowerCase();
        if (ext === "pdf") return <FontAwesomeIcon icon={faFilePdf} size="3x" className="text-danger" />;
        if (["doc", "docx"].includes(ext)) return <FontAwesomeIcon icon={faFileWord} size="3x" className="text-primary" />;
        if (["xls", "xlsx"].includes(ext)) return <FontAwesomeIcon icon={faFileExcel} size="3x" className="text-success" />;
        return <FontAwesomeIcon icon={faFileAlt} size="3x" className="text-secondary" />;
    };

    const getDocIcon = (type) => {
        if (type.includes("pdf")) return faFilePdf;
        if (type.includes("word")) return faFileWord;
        if (type.includes("excel") || type.includes("spreadsheet")) return faFileExcel;
        return faFileAlt;
    };

    // ──────────────────────────────────────────────────────────────
    // 3. UPLOAD DOCUMENT TO SERVER (same pattern as image upload)
    // ──────────────────────────────────────────────────────────────
    const AddNoticeDocument = async () => {
        if (!selectedDocument) return;

        setLoading(true);

        const reader = new FileReader();

        reader.onload = async () => {
            try {
                const auth = localStorage.getItem("userData");
                const myUserData = JSON.parse(auth);

                // Get correct MIME type based on file extension
                const fileExtension = selectedDocument.name.split('.').pop().toLowerCase();
                let mimeType = "";

                if (["pdf"].includes(fileExtension)) {
                    mimeType = "application/pdf";
                } else if (["xlsx"].includes(fileExtension)) {
                    mimeType = "application/xlsx";
                } else if (["xls"].includes(fileExtension)) {
                    mimeType = "application/xls";
                } else if (["doc", "docx"].includes(fileExtension)) {
                    mimeType = "application/msword";
                } else if (fileExtension === "txt") {
                    mimeType = "text/plain";
                } else {
                    mimeType = selectedDocument.type || "application/octet-stream"; // fallback
                }

                // Extract pure Base64 (without "data:...;base64," prefix)
                const base64String = reader.result.split(',')[1];

                // Reconstruct correct data URL with proper MIME
                const dataUrl = `data:${mimeType};base64,${base64String}`;

                const payload = {
                    createdUserId: myUserData?.userId?.toString(),
                    noticeId: NoticeAddId,
                    docImage: dataUrl,
                    orginalFileName:selectedDocument?.name || "",
                    fileType: "ATTACHMENT"
                };

                const endPointVariableKey = {
                    urlVariable: null,
                    buildingId: myUserData?.buildingId

                }

                const response = await commonAPI("NoticeDocumentUpload", payload, endPointVariableKey);

                if (response?.success && response?.message?.length === 0) {
                    toast.success("Document uploaded successfully");

                    GetNoticeImages(); // Refresh preview

                    // Reset form
                    setSelectedDocument(null);
                    setUploadDocBtn(false);
                    // document.getElementById("doc-upload")?.value = "";
                } else {
                    toast.error(response?.message?.[0] || "Upload failed");
                }
            } catch (err) {
                console.log("error is", err)
                toast.error("Upload err");
            } finally {
                setLoading(false);
            }
        };

        reader.onerror = () => {
            toast.error("Failed to read file");
            setLoading(false);
        };

        reader.readAsDataURL(selectedDocument); // This triggers onload
    };



    const [file, setFile] = useState();



    const handleFileInputChangeTwo = (event) => {
        const file = event.target.files[0];
        if (file) {
            if (!/\.(jpeg|jpg|png)$/i.test(file?.name)) {
                toast.error("Please select an image in JPEG, JPG, or PNG format.");
                setFile("")
                return
            } else if (file?.size >= 512000) {
                toast.error("Please select an Image below 500kb size.");
                setFile("")
                return
            } else {
                const reader = new FileReader();
                reader.onload = () => {
                    // atob(item?.logo)
                    const encodedString = btoa(reader.result);
                    console.log("btoa", encodedString);
                    setSelectedImageTwo(reader.result);
                    setSelectedImageTwoShow(reader.result);
                };
                reader.readAsDataURL(file);
            }
        }
    };

    return (
        <>
            {Loading ?
                <div className="loaderDiv">
                    <div className="loader"></div>
                </div>
                : null}
            <ToastContainer />
            {/* <Menus /> */}
            <section id="client-builder">
                <div className="container-fluid pt-2" style={{ paddingTop: "95px !important" }}>
                    <div className="row mb-3 mt-5 pt-2" style={{ alignItem: 'center' }}>
                        <div className="col-md-4">
                            <div className="HeadingTop">
                                <h3> Notice Management </h3>
                                <span> Create, schedule, and distribute important notices to residents.</span>
                            </div>
                        </div>
                        <div className="col-md-3 offset-md-5 text-right" style={{ alignContent: 'center' }}>
                            <select size="md" className="sltareamodal col-5 ml-auto bg-white" onChange={(e) => {
                                console.log("selection", e.target.value)
                                setStatusSelected(e.target.value)
                            }
                            }>
                                <option value="PENDING">Pending</option>
                                <option value="APPROVED">Approved</option>
                                <option value="REJECTED">Rejected</option>
                                <option value="EXPIRED">Expired</option>
                            </select>{" "}
                            <Button onClick={openCreateModal} className="createClr">
                                {" "}
                                + Create New
                            </Button>{" "}
                            <br />
                            <div className="flex_ptrn">
                                <div className="clrptrn">
                                    <div class="red"> </div><span> High </span>
                                </div>
                                <div className="clrptrn">
                                    <div class="orange"> </div><span> Medium  </span>
                                </div>
                                <div className="clrptrn">
                                    <div class="green"> </div><span> Low </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container-fluid">
                        {/* <div className="row page-titles">
                <div className="col-md-12 align-self-end text-right">
                     <button type="button" className="btn btn-info" onClick={() => openCreateModal()}><FontAwesomeIcon icon={faPlus} /> Create New</button>
                </div>
            </div> */}


                        <Modal scrollable
                            fullscreen={fullscreen}
                            show={show}
                            onHide={() => {
                                setShow(false);
                                // setNoticeShowID("");
                                // setStatusSelected("Pending");
                                setDisablePointerEvents(true);
                            }}
                            className="modal-100w clientmodal"
                            class="modal-dialog modal-fullscreen"
                        >
                            <Modal.Header className="headerMDL" closeButton>
                                <Modal.Title onClick={openCreateModal}>Notice Management</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {!NoticeShow ? <></>
                                    : <h6 className='text-success py-2 pt-0'>Notice created successfully. Notice Id: {NoticeShowID}. You can now add images to the notice.</h6>}
                                {!NoticeUpdateShow ? <></>
                                    : <h6 className='text-success pt-0' >Notice Id: {NoticeShowID}</h6>}
                                <div className="row" id="validation" style={{}}  >
                                    <div className="col-12">
                                        <form
                                            action="#"
                                            className="validation-wizard wizard-circle wizard clearfix"
                                            role="application"
                                            id="steps-uid-0"
                                            novalidate="novalidate"
                                        >
                                            <div>
                                                <div className="row" style={{ height: "460px" }}>
                                                    <div className="row">
                                                        {/* LEFT: NOTICE DETAILS */}
                                                        <div className="col-lg-7 col-md-7 col-sm-12 col-12">
                                                            <div className="row">
                                                                <div className="col-lg-3 col-md-3 col-sm-12 col-12 mb-3">
                                                                    <label>Notice Type <span className="danger">*</span></label>
                                                                    <select
                                                                        className="sltareamodal col-12"
                                                                        value={NoticeTypeId?.[0]?.toString()}
                                                                        onChange={(e) => {
                                                                            const selected = NoticeType.find(t => t.noticeTypeId == e.target.value);
                                                                            setNoticeTypeId(e.target.value);
                                                                            setNoticeTypeText(selected?.noticeTypeText || "");
                                                                        }}
                                                                    >
                                                                        <option value="">Select Type</option>
                                                                        {NoticeType.map((item, idx) => (
                                                                            <option key={idx} value={item.noticeTypeId}>
                                                                                {item.noticeTypeText}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>

                                                                <div className="col-lg-3 col-md-3 col-sm-12 col-12 mb-3">
                                                                    <label>Importance <span className="danger">*</span></label>
                                                                    <select className="sltareamodal col-12" value={Importance} onChange={(e) => setImportance(e.target.value)}>
                                                                        <option value="High">High</option>
                                                                        <option value="Medium">Medium</option>
                                                                        <option value="Low">Low</option>
                                                                    </select>
                                                                </div>

                                                                <div className="col-lg-3 col-md-6 col-sm-12 col-12 mb-3">
                                                                    <label>Effective Start Date <span className="danger">*</span></label>
                                                                    <input type="date" className="form-control" value={StartDate} onChange={(e) => setStartDate(e.target.value)} />
                                                                </div>

                                                                <div className="col-lg-3 col-md-6 col-sm-12 col-12 mb-3">
                                                                    <label>Effective End Date <span className="danger">*</span></label>
                                                                    <input type="date" className="form-control" value={EndDate} onChange={(e) => setEndDate(e.target.value)} />
                                                                </div>

                                                                <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                                                                    <label>Notice Subject <span className="danger">*</span></label>
                                                                    <input type="text" maxLength={60} className="form-control" value={NoticeSubject} onChange={(e) => setNoticeSubject(e.target.value)} />
                                                                </div>

                                                                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                                                    <label>Notice Description <span className="danger">*</span></label>
                                                                    <JoditEditor ref={editor} value={content} onBlur={setContent} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* MIDDLE: IMAGE + DOCUMENT UPLOAD (50%-50%) */}
                                                        <div className="col-lg-3 col-md-3 col-sm-12 col-12 notice_management"
                                                            style={{ height: "422px", display: "flex", flexDirection: "column", pointerEvents: !disablePointerEvents ? 'auto' : 'none' }}>

                                                            {/* TOP 50%: IMAGE UPLOAD */}
                                                            <div className="form-group mb-0"
                                                                style={{ flex: 1, borderBottom: "2px solid #e0e0e0", padding: "10px", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                                                                <div>
                                                                    <label className="font-weight-bold text-center d-block mb-2" style={{ fontSize: "13px", color: '#fff' }}>
                                                                        IMAGE UPLOAD
                                                                    </label>

                                                                    {!selectedImageTwo ? (
                                                                        <>
                                                                            <label htmlFor="file-upload-approve" className="custom-file-upload d-block text-center" style={{ cursor: "pointer" }}>
                                                                                <img src={noticeImageUpload} className="img img-responsive mb-0" style={{ maxHeight: "80px" }} alt="upload" />
                                                                            </label>
                                                                            <input
                                                                                id="file-upload-approve"
                                                                                type="file"
                                                                                accept="image/jpeg,image/png"
                                                                                onChange={handleFileInputChangeTwo}
                                                                                style={{ display: "none" }}
                                                                            />
                                                                        </>
                                                                    ) : (
                                                                        <div className="text-center">
                                                                            <img src={selectedImageTwo} className="img img-responsive rounded" style={{ maxHeight: "80px" }} alt="preview" />
                                                                        </div>
                                                                    )}
                                                                </div>

                                                                <div>
                                                                    <label className="text-danger mb-0 d-block" style={{ fontSize: "11px" }}>* Allowed: JPEG/JPG/PNG</label>
                                                                    <label className="text-danger mb-1 d-block" style={{ fontSize: "11px" }}>* Max size: 500KB</label>

                                                                    {UploadBtn ? (
                                                                        <div className="row mx-0">
                                                                            <div className="col-6 pl-0 pr-1">
                                                                                <button type="button" className="btn btn-sm border bg-white form-control"
                                                                                    onClick={() => { setSelectedImageTwo(null); setSelectedImageTwoShow(null); setUploadBtn(false); }}>
                                                                                    Cancel
                                                                                </button>
                                                                            </div>
                                                                            <div className="col-6 pr-0 pl-1">
                                                                                <Button onClick={AddNoticeImage} className="btn-sm form-control border-secondary">Upload</Button>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="row mx-0">
                                                                            <div className="col-6 pl-0 pr-1"><button type="button" className="btn btn-sm border bg-white form-control" disabled>Cancel</button></div>
                                                                            <div className="col-6 pr-0 pl-1"><Button disabled className="btn-sm bg-secondary form-control border-secondary">Upload</Button></div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            {/* BOTTOM 50%: DOCUMENT UPLOAD */}
                                                            <div className="form-group mb-0"
                                                                style={{ flex: 1, padding: "10px", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                                                                <div>
                                                                    <label className="font-weight-bold text-center d-block mb-2" style={{ fontSize: "13px", color: '#fff' }}>
                                                                        DOCUMENT UPLOAD
                                                                    </label>

                                                                    {!selectedDocument ? (
                                                                        <>
                                                                            <label htmlFor="doc-upload" className="custom-file-upload d-block text-center" style={{ cursor: "pointer" }}>
                                                                                <FontAwesomeIcon icon={faFileUpload} size="4x" className="text-muted" />
                                                                            </label>
                                                                            <input
                                                                                id="doc-upload"
                                                                                type="file"
                                                                                accept=".pdf,.doc,.docx,.xls,.xlsx,.txt"
                                                                                onChange={handleDocumentChange}
                                                                                style={{ display: "none" }}
                                                                            />
                                                                        </>
                                                                    ) : (
                                                                        <div className="text-center">
                                                                            <FontAwesomeIcon icon={getDocIcon(selectedDocument.type)} size="3x" className="text-primary mb-2" />
                                                                            <p className="mb-0 text-truncate" style={{ maxWidth: "100%", color:"#fff"}}>{selectedDocument.name}</p>
                                                                        </div>
                                                                    )}
                                                                </div>

                                                                <div>
                                                                    <label className="text-danger mb-0 d-block" style={{ fontSize: "11px" }}>* Allowed: PDF, DOC, XLS, TXT</label>
                                                                    <label className="text-danger mb-1 d-block" style={{ fontSize: "11px" }}>* Max size: 5MB</label>

                                                                    {UploadDocBtn ? (
                                                                        <div className="row mx-0">
                                                                            <div className="col-6 pl-0 pr-1">
                                                                                <button type="button" className="btn btn-sm border bg-white form-control"
                                                                                    onClick={() => { setSelectedDocument(null); setUploadDocBtn(false); }}>
                                                                                    Cancel
                                                                                </button>
                                                                            </div>
                                                                            <div className="col-6 pr-0 pl-1">
                                                                                <Button onClick={AddNoticeDocument} className="btn-sm form-control border-secondary">Upload</Button>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="row mx-0">
                                                                            <div className="col-6 pl-0 pr-1"><button type="button" className="btn btn-sm border bg-white form-control" disabled>Cancel</button></div>
                                                                            <div className="col-6 pr-0 pl-1"><Button disabled className="btn-sm bg-secondary form-control border-secondary">Upload</Button></div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* RIGHT: PREVIEW — EXACT SAME DESIGN AS YOUR REFERENCE */}
                                                        <div className="col-lg-2 col-md-2 col-sm-12 col-12 pr-0">
                                                            <div className="uploadnotice" style={{ height: "422px", display: "flex", flexDirection: "column" }}>

                                                                <span style={{ display: "block", textAlign: "center", padding: "8px 0", background: "#f8f9fa", fontWeight: "bold", fontSize: "14px" }}>
                                                                    Uploaded Files Preview
                                                                </span>

                                                                <div style={{ flex: 1, overflowY: "auto", padding: "10px" }}>
                                                                    <ul style={{ padding: 0, margin: 0, listStyle: "none" }}>
                                                                        {NoticeImages?.length > 0 ? (
                                                                            NoticeImages.map((item, i) => {
                                                                                const isImg = /\.(jpg|jpeg|png|gif|webp|svg)$/i.test(item.docImage);
                                                                                return (
                                                                                    <li key={i} style={{ marginBottom: "15px", textAlign: "center", position: "relative" }}>
                                                                                        <div className="RelativeDel">
                                                                                            {UpdateShow && (
                                                                                                <FontAwesomeIcon
                                                                                                    icon={faTimes}
                                                                                                    onClick={() => ShowDeleteImgModal(item)}
                                                                                                    className="deleteupload"
                                                                                                />
                                                                                            )}
                                                                                        </div>

                                                                                        {isImg ? (
                                                                                            <img
                                                                                                src={item.docImage}
                                                                                                className="img img-responsive"
                                                                                                style={{ maxHeight: "120px", borderRadius: "6px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
                                                                                                alt="preview"
                                                                                            />
                                                                                        ) : (
                                                                                            <a href={item.docImage} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "#333" }}>
                                                                                                <div style={{ padding: "20px", border: "2px dashed #ccc", borderRadius: "8px", background: "#f9f9f9" }}>
                                                                                                    {getFileIconFromUrl(item.docImage)}
                                                                                                    <p style={{ margin: "8px 0 0", fontSize: "12px", wordBreak: "break-all" }}>
                                                                                                        {
                                                                                                            // getFileName(item.docImage)
                                                                                                            item?.orginalFileName
                                                                                                        }
                                                                                                    </p>
                                                                                                </div>
                                                                                            </a>
                                                                                        )}
                                                                                    </li>
                                                                                );
                                                                            })
                                                                        ) : (
                                                                            <div className="text-center text-muted" style={{ paddingTop: "80px" }}>
                                                                                <FontAwesomeIcon icon={faFileAlt} size="4x" className="mb-3" style={{ opacity: 0.3 }} />
                                                                                <h6>No Files Uploaded</h6>
                                                                            </div>
                                                                        )}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='row cutomStriper'>
                                                    <div className='' style={{
                                                        backgroundColor: '#ffffff',
                                                        margin: '0px 15px',
                                                        width: '96%',
                                                        padding: '5px 0px',
                                                        borderRadius: '5px'
                                                    }}>
                                                        {UpdateShow ? <>
                                                            {!UpdateNoticeBtn ?
                                                                <div className="col-lg-12 col-md-12 col-sm-12 col-12 pl-0 align-self-start d-flex">
                                                                    <button type="button" className="btn btn-info createClr" onClick={AddNoticeData}> Submit</button>
                                                                    <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button>

                                                                </div>
                                                                : <div className="col-lg-12 col-md-12 col-sm-12 col-12 pl-0 align-self-start d-flex">
                                                                    <button type="button" className="btn btn-info createClr" onClick={UpdateNoticeData}> Update</button>
                                                                    <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button>

                                                                </div>}</>
                                                            :
                                                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 pl-0 align-self-start d-flex">
                                                                <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button>

                                                            </div>}
                                                    </div>
                                                </div>

                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>

                        <div className="row">
                            <div className="col-12">
                                <div className='row'>
                                    {NoticeList ? NoticeList.map((item, index) =>
                                        <div key={index} className="OneTile">
                                            <div className="ex_feild">
                                                {item?.importance.toUpperCase() == "MEDIUM" ?
                                                    <span className="imp_med"> </span>
                                                    : null}

                                                {item?.importance.toUpperCase() == "HIGH" ?
                                                    <span className="imp_high"> </span>
                                                    : null}

                                                {item?.importance.toUpperCase() == "LOW" ?
                                                    <span className="imp_Low"> </span>
                                                    : null}
                                            </div>
                                            <div className="NoticeFeild">
                                                <h1> {item.noticeSubject}</h1>
                                                <h2> {item.noticeTypeText} </h2>

                                                <div className="onboardFlex">
                                                    {/* <h4> Current Status </h4> */}
                                                    <span> {item.currentStatus} </span>
                                                </div> <br />
                                                <div className="onboardFlex" style={{ whiteSpace: "nowrap" }}>
                                                    <h4> Expiring On </h4>
                                                    <span> {convertISTTime(item.effectiveEndDt)} </span>
                                                    {/* <div className="onboardFont" style={{ marginLeft: item?.currentStatus == "REJECTED" || item?.currentStatus == "APPROVED" ? "36px" : "27px" }} >

                                                        {item?.currentStatus != "REJECTED" && item?.currentStatus != "APPROVED" && <FontAwesomeIcon
                                                            className="editNotice font_trigger"
                                                            icon={faPenToSquare}
                                                            onClick={() => setInputValue(item)}
                                                        />}
                                                        {item?.currentStatus != "APPROVED" && <FontAwesomeIcon className="deleteNotice font_trigger" onClick={() => ShowDeleteModal(item)} icon={faTrash} />}
                                                        {item?.currentStatus == "APPROVED" && <FontAwesomeIcon className="deleteNotice font_trigger ml-3" onClick={() => viewModal(item)} icon={faPodcast} />}
                                                        {item?.currentStatus == "REJECTED" && <FontAwesomeIcon className="deleteNotice font_trigger" onClick={() => viewModal(item)} icon={faPodcast} />}

                                                    </div> */}

                                                    <div className="onboardFont" style={{ marginLeft: "5px", display: "flex", gap: "3px", alignItems: "center" }}>
                                                        {/* EDIT ICON - Show for PENDING & APPROVED */}
                                                        {((item?.currentStatus === "PENDING" || item?.currentStatus === "APPROVED") && StatusSelected !== "EXPIRED" && UserData?.roleName?.toUpperCase() !== "SOCIETY OPERATOR") && (
                                                            <FontAwesomeIcon
                                                                className="editNotice font_trigger"
                                                                icon={faPenToSquare}
                                                                title="Edit Notice"
                                                                style={{ cursor: "pointer", fontSize: "15px" }}
                                                                onClick={() => {
                                                                    setInputValue(item);
                                                                    setDisablePointerEvents(false);

                                                                }}
                                                            />
                                                        )}

                                                        {/* DELETE ICON - Show for PENDING & APPROVED */}
                                                        {((item?.currentStatus === "PENDING" || item?.currentStatus === "APPROVED") && StatusSelected !== "EXPIRED" && UserData?.roleName?.toUpperCase() !== "SOCIETY OPERATOR") && (
                                                            <FontAwesomeIcon
                                                                className="deleteNotice font_trigger"
                                                                icon={faTrash}
                                                                title="Delete Notice"
                                                                style={{ cursor: "pointer", fontSize: "15px" }}
                                                                onClick={() => ShowDeleteModal(item)}
                                                            />
                                                        )}

                                                        {/* BROADCAST/VIEW ICON - Show for APPROVED & REJECTED */}
                                                        {(item?.currentStatus === "REJECTED" || StatusSelected === "EXPIRED" || UserData?.roleName?.toUpperCase() == "SOCIETY OPERATOR") && (
                                                            <FontAwesomeIcon
                                                                className="viewNotice font_trigger"
                                                                icon={faPodcast}
                                                                title="View Broadcast History"
                                                                style={{ cursor: "pointer", fontSize: "15px" }}
                                                                onClick={() => viewModal(item)}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}
                                    {!NoticeList?.length ? (NoticeList?.length == 0 && NoticeList?.length != null &&
                                        <div className='bg-white' style={{ paddingBottom: "50px", borderRadius: "10px" }}>
                                            <div className='col-12 text-center'>
                                                <img src={FlatIcon} alt="user" class="mx-auto mt-5" style={{ height: "100px" }} />
                                            </div>
                                            <br />
                                            <h3 className='col-12 text-center NoDataShowTextColor' style={{ marginTop: "0px" }}> No Notice Found</h3>
                                            <h5 className='col-12 text-center NoDataShowTextColor' style={{ marginTop: "10px" }}> Click on Create New button to add a Notice</h5>
                                        </div>) : null}
                                </div>
                            </div>
                        </div>
                        <Modal centered show={DeleteShowImg} onHide={() =>
                            setDeleteShowImg(false)} className="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
                            {/* <Modal.Header className="headerMDL" closeButton>
                <Modal.Title id="contained-modal-title-vcenter" centered onClick={openCreateModal}>
                    <h4 className="mb-0"> Delete Image </h4>
                </Modal.Title>
            </Modal.Header> */}
                            <Modal.Body className='p-0' style={{ borderRadius: "10px", overflow: "hidden" }}>
                                <div className="row px-3" id="validation">
                                    <div className="col-12 bg-white pt-3 pb-2">
                                        <div className="FnFItem" style={{ justifyContent: "flex-start" }}>
                                            {/* <div className="FnFimg">
                                <img src={stopMark} className='img img-fluid img-responsive'  alt="placeholder" />
                            </div> */}
                                            <div className="FnFtxt">
                                                <h2> Delete Image  </h2>
                                                <h3> Are you sure you want to delete? </h3>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div className='confirmation_btn pb-4 pt-3 px-3' style={{ justifyContent: "center", borderTop: "1px solid #dadada" }}>
                                    <div className='both_ConfrmBTN col-6' onClick={DeleteNoticeImages}>
                                        <Button variant="danger">Delete</Button>{' '}
                                    </div>
                                    <div className='both_ConfrmBTN col-6' onClick={() => setDeleteShowImg(false)} >
                                        <Button variant="light"> Cancel</Button>{' '}
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                        <Modal centered show={DeleteShow} onHide={() =>
                            setDeleteShow(false)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
                            {/* <Modal.Header className="headerMDL" closeButton>
                <Modal.Title id="contained-modal-title-vcenter" centered onClick={openCreateModal}>
                    <h4 className="mb-0"> Delete Notice </h4>
                </Modal.Title>
            </Modal.Header> */}
                            <Modal.Body className='p-0' style={{ borderRadius: "10px", overflow: "hidden" }}>
                                <div className="row px-3" id="validation">
                                    <div className="col-12 bg-white pt-3 pb-2">
                                        <div className="FnFItem" style={{ justifyContent: "flex-start" }}>
                                            {/* <div className="FnFimg">
                                <img src={stopMark} className='img img-fluid img-responsive'  alt="placeholder" />
                            </div> */}
                                            <div className="FnFtxt">
                                                <h2> Delete Notice  </h2>
                                                <h3> Are you sure you want to delete? </h3>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div className='confirmation_btn pb-4 pt-3 px-3' style={{ justifyContent: "center", borderTop: "1px solid #dadada" }}>
                                    <div className='both_ConfrmBTN col-6' onClick={DeleteNotice}>
                                        <Button variant="danger">Delete</Button>{' '}
                                    </div>
                                    <div className='both_ConfrmBTN col-6' onClick={() => setDeleteShow(false)} >
                                        <Button variant="light"> Cancel</Button>{' '}
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                    </div>

                </div>
            </section>
        </>)

}
export default Noticemanagement 